<template>
  <main-content>
    <b-card>
      <ERegistrationHeaderFormInfo />
      <ERegistrationPublicTermCondFormForPublic  :businessId="businessId"  />
      
    </b-card>
  </main-content>
</template>

<script>
import ERegistrationProfessionalRegisterForm from "../components/e-registration-professional-register/ERegistrationProfessionalRegisterForm";
import ERegistrationHeaderFormInfo from "../components/e-registration-header-form/ERegistrationHeaderFormInfo";
import ERegistrationPublicTermCondFormForPublic from "../components/ERegistrationPublicTermCondFormForPublic";

export default {
  props: [ "businessId"],
  components: {
    ERegistrationHeaderFormInfo,
    ERegistrationPublicTermCondFormForPublic,
    ERegistrationProfessionalRegisterForm
  },
  beforeRouteEnter(to, from, next) {

      next();

  },
  data() {
    return {
      accepted: false,
      errors: [],
      errorMsg: "",
    };
  },
};
</script>

<style lang="scss" scoped></style>
